module.exports = __webpack_public_path__ + "68496a76cf6e6304288aa0381e68100d.jpg";